<template>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="目标年份">
                    <el-date-picker
                        v-model="searcheModel.year"
                        type="year"
                        format="yyyy"
                        value-format="yyyy"
                        placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    :filename="searcheModel.active_name == 'branch-goal' ? '回款业绩目标(部门)' : '回款业绩目标(成员)'" 
                    buttonName="导出Excel"
                    buttonType="success">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="21">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="handleClick">
                    <el-tab-pane label="按部门" name="1"></el-tab-pane>
                    <el-tab-pane label="按成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="3">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="activeName"></CountConfig>
            </el-col>
        </el-row>
        <h3>回款业绩目标</h3>
        <el-table 
        v-if="!loading"
        :data="list" 
        border 
        height="450"
        row-key="id" 
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :header-cell-style="{background: '#f3faff'}"
        :summary-method="getSummaries"
        show-summary
        key="1"
        >
            <template v-if="searcheModel.count_type == 1">
                <el-table-column prop="branch_name" label="部门" width="120"></el-table-column>
            </template>
            <template v-else>
                <el-table-column prop="user_name" label="业务员"></el-table-column>
                <el-table-column prop="role_name" label="所属职位"></el-table-column>
                <el-table-column prop="branch_name" label="所属部门"></el-table-column>
            </template>
            <el-table-column prop="sum" label="目标合计"></el-table-column>
            <el-table-column prop="january" sortable label="1月"></el-table-column>
            <el-table-column prop="february" sortable label="2月"></el-table-column>
            <el-table-column prop="march" sortable label="3月"></el-table-column>
            <el-table-column prop="april" sortable label="4月"></el-table-column>
            <el-table-column prop="may" sortable label="5月"></el-table-column>
            <el-table-column prop="june" sortable label="6月"></el-table-column>
            <el-table-column prop="july" sortable label="7月"></el-table-column>
            <el-table-column prop="august" sortable label="8月"></el-table-column>
            <el-table-column prop="september" sortable label="9月"></el-table-column>
            <el-table-column prop="october" sortable label="10月"></el-table-column>
            <el-table-column prop="november" sortable label="11月"></el-table-column>
            <el-table-column prop="december" sortable label="12月"></el-table-column>
        </el-table>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import ImportFile from "~/widgets/ImportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        ImportFile,
        CountConfig
    },
  
    props: {
        is_edit: {
            type: Boolean,
            default: false
        },
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {},
        };
    },
  
    mounted() {
        this.resetForm();
    },
  
    created() {
        
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                count_type: '1',
                year: new Date().getFullYear().toString(),
                path: this.$route.path,
                tab: this.activeName,
                active_name: 'branch-goal',
                type: 3
            };
            this.$refs['user'].reset();
            this.$refs['branch'].reset();
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        handleClick(){
            this.searcheModel.active_name = 'branch-goal';
            if(this.searcheModel.count_type == 2){
                this.searcheModel.active_name = 'user-goal';
            }
            this.submitSearch();
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/goalManageActual.vue